import { render, staticRenderFns } from "./QyXkxx.vue?vue&type=template&id=44853a68&scoped=true"
import script from "./QyXkxx.vue?vue&type=script&lang=js"
export * from "./QyXkxx.vue?vue&type=script&lang=js"
import style0 from "./QyXkxx.vue?vue&type=style&index=0&id=44853a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44853a68",
  null
  
)

export default component.exports